import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend, Ticks } from "chart.js";
import { Bar, Chart } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { firebaseToString } from '../../Tools/tools';

function flattenGraphData(data) {
    let graphData = {}

    let acc = 0
    let count = 0

    for (const [depName, amountPresent] of Object.entries(data)) {
        graphData[firebaseToString(depName)] = (amountPresent * 100).toFixed(0)

        acc += amountPresent
        count += 1
    }

    graphData["TODOS"] = ((acc / count) * 100).toFixed(0)

    return graphData
}

function getHighest(data) {
    let highest = 0

    data.forEach((value) => {
        value = parseInt(value)
        if (value > highest) {
            highest = value
        }
    })

    return parseInt(highest) + 14
}

function DepCurrentMonthGraph(props) {

    let graphWidth = 12

    ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels)

    const graphData = flattenGraphData(props.data)

    if (Object.keys(graphData)) {
        if (Object.keys(graphData).length >= 15) {
            graphWidth = 12
        } else {
            graphWidth = 6
        }
    }

    const labels = Object.keys(graphData)
    const values = Object.values(graphData)

    const data = {
        labels,
        datasets: [
            {
                label: "% Presença",
                data: values,
                backgroundColor: '#255683'
            }
        ]
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                color: '#000',
                clip: true,
                align: 'top',
                anchor: 'end',
                clamp: true,
                font: {
                    size: 16
                },
                formatter: function (value, context) {
                    return `${value}%`
                }
            }
        },
        layout: {
            padding: 0
        },
        scales: {
            y: {
                beginAtZero: true,
                max: getHighest(values),
                ticks: {
                    display: false   // hides the numbers
                },
                grid: {
                    drawTicks: false // optional, hides tick marks
                }
            },
            x: {
                ticks: {
                    autoSkip: false
                }
            }
        }
    }

    return <Col md={graphWidth}>
        <h5>Aderência ao programa de ginástica laboral - Mensal</h5>
        <Bar data={data} options={options} />
    </Col>
}

export default DepCurrentMonthGraph